import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {Formik} from "formik";
import {Button} from "react-bootstrap";
import {DataItem} from "../../../../_common/components/DataItem/DataItem";
import {checkEmailIsValid} from '../../../../_common/utils/checkEmailIsValid';
import {createPartner} from "../../../_redux/partnersActions";

const AddPartnerForm = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);

  const intl = useIntl();
  const buttonShowLabel = intl.formatMessage({
    id: 'partners-popup-manage-show-form-label',
    defaultMessage: 'Add partner',
  });
  const buttonHideLabel = intl.formatMessage({
    id: 'partners-popup-manage-hide-form-label',
    defaultMessage: 'Hide form',
  });
  const buttonSubmitLabel = intl.formatMessage({
    id: 'partners-popup-manage-submit-label',
    defaultMessage: 'Submit',
  });
  const invalidEmail = intl.formatMessage({
    id: 'invalid-email-message',
    defaultMessage: 'Invalid email',
  });

  const validate = (values) => {
    let errors = {};
    const {
      name,
      contactName,
      phone,
      email,
      idNumber,
      uniqueId,
      description,
    } = values;

    if (!checkEmailIsValid(email)) {
      errors.email = 'Invalid email address';
    }

    const arr = Object.keys({
      name,
      contactName,
      phone,
      email,
      idNumber,
      uniqueId,
      description,
    });
    arr.forEach(function (item) {
      if (!values[item]) errors[item] = 'Required';
    });

    return errors;
  };

  const fields = [
    {
      key: 0,
      fieldId: 'name',
      label: intl.formatMessage({
        id: 'partners-popup-manage-form-name',
        defaultMessage: 'Name',
      })
    },
    {
      key: 1,
      fieldId: 'contactName',
      label: intl.formatMessage({
        id: 'partners-popup-manage-form-contactName',
        defaultMessage: 'Contact name',
      })
    },
    {
      key: 2,
      fieldId: 'phone',
      label: intl.formatMessage({
        id: 'partners-popup-manage-form-phone',
        defaultMessage: 'Phone',
      })
    },
    {
      key: 3,
      fieldId: 'email',
      label: intl.formatMessage({
        id: 'partners-popup-manage-form-email',
        defaultMessage: 'Email',
      })
    },
    {
      key: 4,
      fieldId: 'idNumber',
      label: intl.formatMessage({
        id: 'partners-popup-manage-form-id',
        defaultMessage: 'ID',
      })
    },
    {
      key: 5,
      fieldId: 'uniqueId',
      label: intl.formatMessage({
        id: 'partners-popup-manage-form-uniqueId',
        defaultMessage: 'Unique ID',
      })
    },
    {
      key: 6,
      fieldId: 'description',
      label: intl.formatMessage({
        id: 'partners-popup-manage-form-description',
        defaultMessage: 'Description',
      })
    },
  ];
  const getFields = (item, values) => {
    return (
      <div className={'position-relative'}>
        <DataItem
          fieldId={item.fieldId}
          label={
            <div className={'d-flex'}>
              <span className={'text-danger ml-1'}>*</span>
              <span>{item.label}</span>
            </div>
          }
          topLabelStyle={'custom-brand-color'}
        />
        {(Boolean(values.email && !checkEmailIsValid(values.email) && item.key === 3)) ?
          (<div className='invalid-email-message invalid-email-message-partners'>{invalidEmail}</div>)
          : null
        }
      </div>
    )
  };

  const createPartnerFunc = (values, resetForm) => {
    dispatch(createPartner(values));
    setShowForm(false);
    resetForm();
  };

  return (
    <Formik
      initialValues={{
        name: '',
        contactName: '',
        phone: '',
        email: '',
        idNumber: '',
        uniqueId: '',
        description: '',
      }}
      onSubmit={() => {
      }}
      validate={validate}
      enableReinitialize={true}
    >
      {({
          values,
          isValid,
          dirty,
        resetForm
        }) => (
        <div className={'mb-8'}>
          <div className={'d-flex justify-content-center my-6'}>
            <Button
              className={`btn btn-sm ${showForm ? 'btn-secondary' : 'custom-subheader-button'} col-2`}
              onClick={() => setShowForm(!showForm)}
            >
              {showForm ? buttonHideLabel : buttonShowLabel}
            </Button>
          </div>
          {showForm && (
            <form
              className={'d-flex align-items-center flex-column w-900px mx-auto'}
            >
              <div className={'d-flex justify-content-between mb-4 w-100'}>
                {[fields[0], fields[1], fields[2]].map(item => getFields(item, values))}
              </div>
              <div className={'d-flex justify-content-between mb-4 w-100'}>
                {[fields[3], fields[4], fields[5]].map(item => getFields(item, values))}
              </div>
              <div className={'mb-4 w-100'}>
                {[fields[6]].map(item => getFields(item, values))}
              </div>
              <div className={'d-flex justify-content-center mb-4'}>
                <Button
                  className={'btn btn-sm custom-subheader-button'}
                  onClick={() => createPartnerFunc(values, resetForm)}
                  disabled={!(isValid && dirty)}
                >
                  {buttonSubmitLabel}
                </Button>
              </div>
            </form>
          )}
        </div>
      )}
    </Formik>
  );
};

export default AddPartnerForm;
